import React, { useEffect, useCallback } from 'react';

import { useQuery, useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import mexicoFlag from '../../../assets/images/icons/mexicoFlag.svg';
import usFlag from '../../../assets/images/icons/usFlag.svg';
import AuthService from '../../../services/AuthService';
import UserService from '../../../services/UserService';

export default function LanguageSelector() {
  const { i18n } = useTranslation();

  const { data: me } = useQuery({
    queryKey: ['me'],
    queryFn: AuthService.getMe,
    retry: false,
  });

  const { mutate: updateMe } = useMutation({
    mutationFn: () => {
      return UserService.updateMe({
        ...me,
        preference_language: i18n.language === 'en' ? 'English' : 'Spanish',
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const switchLanguage = useCallback(() => {
    i18n.changeLanguage(i18n.language === 'en' ? 'es' : 'en');
    updateMe();
  }, [i18n, updateMe]);

  useEffect(() => {
    const languages = {
      English: 'en',
      Spanish: 'es',
    };

    if (me && me.preference_language) {
      i18n.changeLanguage(languages[me.preference_language]);
    }
  }, [i18n, me]);

  return (
    <div>
      <button
        type="button"
        className="w-8 h-8 flex items-center justify-center bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600/80 rounded-full"
        onClick={switchLanguage}
      >
        <img
          className="w-4 h-4"
          src={i18n.language === 'en' ? usFlag : mexicoFlag}
          alt="Flag"
        />
      </button>
    </div>
  );
}
